import { PostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface PostHogPageViewProps {
  posthog?: PostHog;
}

export default function PostHogPageView(props: PostHogPageViewProps) {
  const location = useLocation();

  // Track pageviews
  useEffect(() => {
    if (props.posthog) {
      props.posthog.capture("$pageview", {
        $current_url: window.location.href,
      });
    }
  }, [location]);

  return null;
}
